import { GenIcon } from '../helpers/IconBase.es.js';

const FavouriteFilled = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M15.6362 5C14.1086 5 12.8 5.79411 12 6.94863C11.2 5.79411 9.89053 5 8.36379 5C5.96379 5 4 6.94863 4 9.33095C4 12.6413 8.67537 17.2181 10.8775 19.1903C11.5183 19.7638 12.4817 19.7638 13.1217 19.1903C15.3238 17.2181 20 12.6413 20 9.33095C20 6.94863 18.0362 5 15.6362 5Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};

export { FavouriteFilled };
